module.exports = __webpack_public_path__ + "static/media/qigong.81fe3902.svg";